/**
 * /auth/entities 返回的酒店(hotel)/餐厅(restaurant)对象上，menu.sources 是一个数组，
 * 表示该门店当前启用/支持的评价平台代码（如 ["BOOKING","GOOGLE","TRIPADVISOR"]）。
 * 各处"平台卡片"（首页 Platform Overview、Reviews 页（/reviews）的 rating-info 等）应依据
 * 这个白名单来决定是否展示对应平台的卡片。
 *
 * 约定：
 * - sources 为 null/undefined（字段缺失，如后端还未对某类 entity 返回该字段）→ 不做任何限制，
 *   保持调用方原有的展示逻辑，避免因为后端未覆盖而误隐藏所有卡片。
 * - sources 为数组（包括空数组）→ 严格按白名单过滤，数组为空则代表该门店未启用任何平台。
 */

function normalize(sources) {
  return (sources || []).map((s) => String(s).toUpperCase());
}

/** 单个平台代码是否在 sources 白名单内；sources 缺失时视为不限制。 */
export function isSourceEnabled(otas, sources) {
  if (sources == null) return true;
  if (!otas) return false;
  return normalize(sources).includes(String(otas).toUpperCase());
}

/**
 * 按 sources 白名单过滤平台卡片列表。
 * @param {Array} items 平台卡片数组
 * @param {Array|null|undefined} sources menu.sources
 * @param {Function} getKey 从单个 item 取平台代码的方法，默认取 item.otas
 */
export function filterBySources(items, sources, getKey = (item) => item && item.otas) {
  if (!Array.isArray(items)) return items;
  if (sources == null) return items;
  const allow = normalize(sources);
  return items.filter((item) => {
    const key = getKey(item);
    return !!key && allow.includes(String(key).toUpperCase());
  });
}

export function getHotelSources(hotel) {
  return hotel && hotel.menu ? hotel.menu.sources : null;
}

export function getRestaurantSources(restaurant) {
  return restaurant && restaurant.menu ? restaurant.menu.sources : null;
}
